require('../../styles/_icons.scss');
require('../../styles/_block-contact-officer.scss');
const React = require('react');
const { bindActionCreators } = require('redux');
const { connect } = require('react-redux');
import { formatText, FormattedText } from 'core/i18n';

const { Form, Errors } = require('react-redux-form');
const formActions = require('react-redux-form').actions;
const { InputText } = require('components/inputText/inputText');
import { SelectList } from 'components/SelectList/SelectList';
const initialActions = require('actions/initialActions');
const countriesDialCodes = require('./countriesDialCodes.js');
const HighLightedText = require('components/highLightedText/highLightedText');
const { recordCallMeBack } = require('utilities/uTagging');
const dataProtectionClauseURL =
    'https://bancoonline.openbank.es/csopen/Satellite?c=DocumentoGS&canal=CWebComOB&cid=1431483031394&empr=BrokerOpenBank&leng=es_ES&pagename=BrokerOpenBank%2FDocumentoGS%2FDocumentoGSPreview';
const { COUNTRY_PREFIX_ES } = require('constants/multiLanguage');
const { getReferencePrefixByCountry } = require('utilities/multiLanguageHelper');
const { getTypeCallMeBack } = require('utilities/logicByCountry');
import { checkUserInvestmentTypeAndReturnActiveOne } from 'utilities/userProfile';
import ConditionalToggling from 'utilities/toggling/ConditionalToggling/ConditionalToggling';
import { CREDIT_CARD } from 'constants/userProfile';
import TextAreaResizer from 'components/TextAreaResizer/TextAreaResizer';
import IconClose from 'assets/icons/icon-close.svg';
import { CALL_ME_BACK } from 'constants/uTagConstants/RAConstants';

class contactOfficerForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            fieldsError: {},
            isContactPhoneGroupValidate: true,
            showForm: true,
            showSuccess: false,
            disableButton: true,
            acceptTermsReviewed: false,
            callmeBackMessage: '',
        };
        this.handleContactOfficerSubmit = this.handleContactOfficerSubmit.bind(this);
        this.validateContactOfficerRequiredFields = this.validateContactOfficerRequiredFields.bind(this);
        this.buildContactOfficerForm = this.buildContactOfficerForm.bind(this);
        this.buildSuccessView = this.buildSuccessView.bind(this);
        this.validateGroups = this.validateGroups.bind(this);
        this.buildCountryDialCodes = this.buildCountryDialCodes.bind(this);
        this.handleStates = this.handleStates.bind(this);
        this.countriesDialCodes = countriesDialCodes.countriesCodes;
        this.validatePhoneNumber = this.validatePhoneNumber.bind(this);
        this.validateAllFields = this.validateAllFields.bind(this);
        this.checkAcceptTerms = this.checkAcceptTerms.bind(this);
        this.handlePhoneOnFocus = this.handlePhoneOnFocus.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.formRef = React.createRef();
        this.scrollRef = React.createRef();
    }

    UNSAFE_componentWillMount() {
        this.props.formActions.change('userProfile.contactCountryCode', getReferencePrefixByCountry());
    }

    handleClickOutside = event => {
        if (!this.formRef?.current?.contains(event.target)) {
            this.handleCloseModal();
        }
    };

    handleWheel = status => event => {
        event.stopPropagation();
        document.body.style.overflowY = status;
    };

    componentDidMount() {
        document.getElementById('contactFullName').focus();
        document.addEventListener('mousedown', this.handleClickOutside);

        this.scrollRef.current.addEventListener('wheel', this.handleWheel('hidden'));

        document.body.addEventListener('wheel', this.handleWheel('unset'));
    }

    componentWillUnmount() {
        this.scrollRef.current.removeEventListener('wheel', this.handleWheel);
        document.removeEventListener('mousedown', this.handleClickOutside);
        document.body.removeEventListener('wheel', this.handleWheel);
        document.body.style.overflowY = 'unset';
    }

    UNSAFE_componentWillReceiveProps() {
        this.checkAcceptTerms();
        this.handleStates();
    }

    componentDidUpdate() {
        this.checkAcceptTerms();

        return true;
    }

    checkAcceptTerms() {
        const { userProfile, steps } = this.props;
        const acceptTermsReviewed = this.state.acceptTermsReviewed;

        if (userProfile.acceptTerms && !acceptTermsReviewed && steps.get('initialStepComplete')) {
            this.props.formActions.change('userProfile.contactCountryCode', getReferencePrefixByCountry());

            this.setState({ acceptTermsReviewed: true });
        }
    }

    validatePhoneNumber(value) {
        let valid;
        let regx;

        if (this.props.userProfile.contactCountryCode === COUNTRY_PREFIX_ES) {
            regx = /^[6|7|8|9][\d ]{10}$/;
            valid = new RegExp(regx).test(value);
        } else {
            regx = /^[\d ]+$/;
            valid = new RegExp(regx).test(value);
        }

        this.setFieldsError('contactPhone', valid);
        this.validateGroups('contactPhone', valid, value);

        return valid;
    }

    validateFullName(value) {
        let valid;
        const regx = /^[a-zA-ZÀ-ÄÇ-ÏÑ-ÖÙ-Üà-äç-ïñ-öù-ü\s]*$/;

        valid = new RegExp(regx).test(value) && value.length > 0;

        return valid;
    }

    validateGroups(fieldName, valid, value) {
        const { userProfileForm } = this.props;
        const fields = userProfileForm;

        let isContactPhoneGroupValidate = this.state.isContactPhoneGroupValidate;

        if (fieldName === 'contactCountryCode' || fieldName === 'contactPhone') {
            let isCountryCodeValid = true;
            let isPhoneValid = !!(fields.contactPhone && fields.contactPhone.valid);
            if (fieldName === 'contactPhone') {
                isPhoneValid = value !== '' ? valid : false;
                isCountryCodeValid = value !== '' ? valid : false;
            }
            isContactPhoneGroupValidate = isCountryCodeValid && isPhoneValid;

            if (!isContactPhoneGroupValidate) {
                this.props.formActions.setValidity('userProfile.contactCountryCode', { required: false });
            } else {
                this.props.formActions.setValidity('userProfile.contactCountryCode', { required: true });
            }
        }

        this.setState({
            isContactPhoneGroupValidate,
        });
    }

    validateContactOfficerRequiredFields(data) {
        const requiredFields = ['contactFullName', 'contactCountryCode', 'contactPhone'];

        let a = 0;

        for (let i = 0; i < requiredFields.length; i++) {
            if (data[requiredFields[i]] !== '' && typeof data[requiredFields[i]] !== 'undefined') {
                a++;
            } else {
                this.setFieldsError(requiredFields[i], false);
                this.props.formActions.setValidity(`userProfile.${requiredFields[i]}`, { required: false });
            }
        }

        return requiredFields.length === a;
    }

    validateAllFields() {
        const { userProfileForm, userProfile } = this.props;
        let validPhone = false;
        let validName = false;

        if (typeof userProfileForm !== 'undefined') {
            if (
                typeof userProfile.contactPhone !== 'undefined' &&
                userProfile.contactPhone.length > 0 &&
                typeof userProfileForm.contactPhone !== 'undefined'
            ) {
                validPhone =
                    typeof userProfileForm.contactPhone.valid !== 'undefined'
                        ? userProfileForm.contactPhone.valid
                        : false;
            }

            if (
                typeof userProfile.contactFullName !== 'undefined' &&
                userProfile.contactFullName.length > 0 &&
                typeof userProfileForm.contactFullName !== 'undefined'
            ) {
                validName =
                    typeof userProfileForm.contactFullName.valid !== 'undefined'
                        ? userProfileForm.contactFullName.valid
                        : false;
            }
        }

        return !(validPhone && validName);
    }

    handleSaveContactOfficerData() {
        const { userProfile } = this.props;
        const { contactCountryCode, contactFullName, contactPhone, iban, investmentType, userId } = userProfile;
        let page = 'Registro';

        if (typeof iban !== 'undefined') {
            const currentStep = this.props.steps.get('currentStep');

            switch (currentStep) {
                case 0:
                    page = 'Completa tus datos generales';
                    break;
                case 1:
                    page = 'Tu actividad';
                    break;
                case 2:
                    page = 'Identidad';
                    break;
                case 3:
                    page = 'Firma de contrato';
                    break;
                case 4:
                    page = 'Documentación';
                    break;
                default:
                    break;
            }
        }

        const data = {
            type: getTypeCallMeBack(),
            isCustomer: 'non-customer',
            pageTitle: page,
            fullname: contactFullName,
            phone: contactCountryCode + contactPhone.replace(/\s/g, ''),
            timeForContact: null,
            message: this.state.callmeBackMessage,
            // status: userProfile.status ? userProfile.status : 'hazte-cliente',
        };

        const loggedIn = typeof userId !== 'undefined';
        this.props.initialActions.saveCallMEBackRequest(data, function (id) {
            recordCallMeBack(loggedIn, 'exito', id, investmentType ? investmentType : '');
        });
    }

    handleContactOfficerSubmit() {
        const { userProfile, formActions } = this.props;
        const { investmentType } = userProfile;
        this.validateAllFields();
        const validateRequiredFields = this.validateContactOfficerRequiredFields(userProfile);

        const loggedIn = typeof userProfile.userId !== 'undefined';
        recordCallMeBack(loggedIn, 'submit', '', investmentType ? investmentType : '');

        if (!validateRequiredFields) {
            return;
        }
        this.handleSaveContactOfficerData();
        this.setState({
            showForm: false,
            showSuccess: true,
        });

        formActions.change('userProfile.contactFormReset', true);
    }

    sortByCountryCode(a, b) {
        const ONLY_NUMBERS_REGEX = /[^0-9]+/g;
        const current = parseInt(a.value.replace(ONLY_NUMBERS_REGEX, ''));
        const next = parseInt(b.value.replace(ONLY_NUMBERS_REGEX, ''));

        if (current < next) {
            return -1;
        }
        if (current > next) {
            return 1;
        }

        return 0;
    }

    buildCountryDialCodes() {
        const countriesDialCodes = this.countriesDialCodes;
        const phoneCodesOptions = [];

        for (let i = 0; i < countriesDialCodes.length; i++) {
            const option = {
                label: countriesDialCodes[i].dial_code,
                value: countriesDialCodes[i].dial_code,
            };

            if (!phoneCodesOptions.some(phoneCode => phoneCode.label === option.label)) {
                phoneCodesOptions.push(option);
            }
        }

        return phoneCodesOptions.sort(this.sortByCountryCode);
    }

    setFieldsError(fieldName, valid) {
        const fieldsError = this.state.fieldsError;
        fieldsError[fieldName] = valid ? false : ' ';
        this.setState({
            fieldsError,
        });
    }

    handleStates() {
        const { userProfile, formActions } = this.props;

        if (userProfile.contactFormReset) {
            this.setState({
                showForm: true,
                showSuccess: false,
                acceptTermsReviewed: false,
            });

            formActions.change('userProfile.contactFullName', '');
            document.getElementById('contactFullName').value = '';
            formActions.change('userProfile.contactCountryCode', getReferencePrefixByCountry());
            formActions.change('userProfile.contactPhone', '');
            document.getElementById('contactPhone').value = '';
            formActions.change('userProfile.contactFormReset', false);
        }
    }

    goToInput(element) {
        setTimeout(function () {
            let top = 0;

            while (element) {
                top = top + parseInt(element.offsetTop);
                element = element.offsetParent;
            }

            const tooltipPopupFixed = document.getElementById('tooltipPopupFixed');
            tooltipPopupFixed.scrollTop = top - 20;
        }, 500);
    }

    handlePhoneOnFocus(inputPhone) {
        const newInputPhoneValue = document.getElementById(inputPhone).value.replace(/\s/g, '');

        return (document.getElementById(inputPhone).value = newInputPhoneValue);
    }

    handleCloseModal() {
        this.props.handleClose();
    }

    buildContactOfficerForm() {
        const { userProfile, formActions, partner } = this.props;
        const validateGroups = this.validateGroups;
        const DialCodesOptions = this.buildCountryDialCodes();
        const validatePhoneNumber = this.validatePhoneNumber;
        const validateFullName = this.validateFullName;
        const goToInput = this.goToInput;
        const handlePhoneOnFocus = this.handlePhoneOnFocus;

        const showForm = this.state.showForm;
        const disableButton = this.validateAllFields();
        const contactOfficerClass = !showForm ? 'hidden' : '';
        const userInvestmentType = checkUserInvestmentTypeAndReturnActiveOne(userProfile.investmentType);

        return (
            <div id="contactOfficer" className={`contact-officer ${contactOfficerClass}`} ref={this.scrollRef}>
                <div id="contactOfficerTitles" className="contact-officer__header">
                    <div className="contact-officer__close">
                        <img src={IconClose} onClick={this.handleCloseModal} />
                    </div>
                    <h3 className="contact-officer__title">{formatText('tooltip-needHelp')}</h3>
                    <span className="dash-blue"></span>
                    <p className="contact-officer__subtitle">
                        <span className="contact-officer__contact-us">{formatText('tooltip-contactUs')}</span>
                        <span className="contact-officer__contact-number">
                            <ConditionalToggling condition={!userInvestmentType[CREDIT_CARD]}>
                                <a
                                    className="contact-telephone-call"
                                    href={`tel:${formatText('tooltip-conctactNumber')}`}
                                    data-rel="external"
                                >
                                    <i className="icons icons--icon-phone-2"></i>
                                    {formatText('tooltip-conctactNumber')}
                                </a>
                            </ConditionalToggling>
                            {userInvestmentType[CREDIT_CARD] && (
                                <a
                                    className="contact-telephone-call"
                                    href={`tel:${formatText(`tooltip-conctactNumberCreditCard_${partner.get('id')}`)}`}
                                    data-rel="external"
                                >
                                    <i className="icons icons--icon-phone-2" />
                                    {formatText(`tooltip-conctactNumberCreditCard_${partner.get('id')}`)}
                                </a>
                            )}
                        </span>
                    </p>
                    <hr />
                </div>
                <div className="contact-officer__body">
                    <h4 className="contact-officer__we-call-you">{formatText('tooltip-weCallYou')}</h4>
                    <Form model="contactOfficerForm" onSubmit={this.handleContactOfficerSubmit} id="contactOfficerForm">
                        <div className="md-form-group form__group-first">
                            <InputText
                                profileModel="userProfile.contactFullName"
                                label={formatText('field-gdprNamesAndLastNames')}
                                type="text"
                                name="contactFullName"
                                id="contactFullName"
                                validations={{
                                    required: value => value && value.length,
                                    valid: value => validateFullName(value),
                                }}
                                onFocus={function (event) {
                                    goToInput(event.target);
                                }}
                                messagesError={{
                                    required: formatText('validation-fieldRequired'),
                                    valid: formatText('validation-syntaxError'),
                                }}
                                eventCategoryTag={CALL_ME_BACK}
                                {...this.props}
                            />
                        </div>

                        <div className="row md-form-group form__group-inputs">
                            <div className="form__input">
                                <div className="col-lg-12">
                                    <label>{formatText('placeholder-PhoneContact')}</label>
                                </div>
                            </div>
                            <div className="col-xs-4 first-col">
                                <SelectList
                                    profileModel="userProfile.contactCountryCode"
                                    name="countryCode"
                                    placeholder=" "
                                    optionsList={DialCodesOptions}
                                    clearable={false}
                                    required
                                    searchable={true}
                                    isUpdated={function () {
                                        if (
                                            typeof userProfile.contactPhone !== 'undefined' &&
                                            userProfile.contactPhone !== ''
                                        ) {
                                            const profileModel = 'userProfile.contactPhone';
                                            const validations = {
                                                valid: value => validatePhoneNumber(value),
                                            };
                                            const newValidations = {};
                                            for (let i = 0; i < validations.length; i++) {
                                                if (validations[i] === 'required') {
                                                    newValidations.required = validations.required;
                                                }
                                                if (validations[i] === 'valid') {
                                                    newValidations.valid = validations.valid;
                                                }
                                            }

                                            formActions.validate(profileModel, newValidations);
                                        }
                                        document.getElementById('contactPhone').focus();
                                    }}
                                    messagesError={{
                                        required: ' ',
                                    }}
                                    {...this.props}
                                />
                            </div>
                            <div className="col-xs-8 last-col-input">
                                <InputText
                                    profileModel="userProfile.contactPhone"
                                    type="text"
                                    name="contactPhone"
                                    id="contactPhone"
                                    maxLength={12}
                                    onKeyDown={e => {
                                        const numberRegex = /^[0-9]$/;
                                        if (!numberRegex.test(e.key) && e.key.length === 1) {
                                            e.preventDefault();
                                        }
                                    }}
                                    validations={{
                                        required: value => value && value.length,
                                        valid: value => validatePhoneNumber(value),
                                    }}
                                    isNotValidated={function (value) {
                                        validateGroups('contactPhone', false, value);
                                    }}
                                    isValidated={function (value) {
                                        validateGroups('contactPhone', true, value);
                                    }}
                                    onFocus={function (event) {
                                        handlePhoneOnFocus('contactPhone');
                                        goToInput(event.target);
                                    }}
                                    onBlur={function (value) {
                                        return value.replace(/(\d{3})(\d{3})(\d{3})/, '$1 $2 $3');
                                    }}
                                    eventCategoryTag={CALL_ME_BACK}
                                    displayErrors={false}
                                    {...this.props}
                                />
                            </div>

                            <div className="col-xs-12">
                                <Errors
                                    className="form__field_error"
                                    model="userProfile.contactPhone"
                                    messages={{
                                        valid: formatText('validation-cellPhone'),
                                        required: formatText('validation-fieldRequired'),
                                    }}
                                    component={this.renderErrors}
                                />
                            </div>
                        </div>

                        <div className="row md-form-group">
                            <TextAreaResizer
                                labelClass="form__input"
                                autoFocus={false}
                                label={formatText('field-callmeBackMessage')}
                                name="callMeBackMessage"
                                id="callMeBackMessage"
                                setValue={value => this.setState({ callmeBackMessage: value })}
                            />
                        </div>

                        <HighLightedText
                            className="form__hightlight-text form__hightlight-text--disclaimer contact-officer__disclaimer"
                            icon={<i className="icons icons--icon-exclamation"></i>}
                        >
                            <FormattedText
                                value="tooltip-gdprDataProtectionClause"
                                injectedStrings={[dataProtectionClauseURL]}
                            />
                        </HighLightedText>
                    </Form>
                </div>
                <div className="contact-officer__footer">
                    <hr />

                    <div className="text-right contact-officer__submit-button">
                        <button
                            form="contactOfficerForm"
                            type="submit"
                            className="form__button form__button-secondary"
                            disabled={disableButton}
                        >
                            {formatText('button-accept')}
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    buildSuccessView() {
        const showSuccess = this.state.showSuccess;
        const showSuccesClass = `contact-officer__success${!showSuccess ? ' hidden' : ''}`;

        return (
            <div className={`contact-officer ${showSuccesClass}`}>
                <div id="contactOfficerTitles" className="contact-officer__header">
                    <div className="contact-officer__close">
                        <img src={IconClose} onClick={this.handleCloseModal} />
                    </div>
                </div>
                <div className="contact-officer__body">
                    <i className="icons icons--icon-checked"></i>
                    <h3 className="contact-officer__success__title">{formatText('tooltip-thankYouForContacting')}</h3>
                    <p className="contact-officer__success__subtitle">{formatText('tooltip-weWillContactYou')}</p>
                </div>
            </div>
        );
    }

    render() {
        const viewForm = this.buildContactOfficerForm();
        const viewSuccess = this.buildSuccessView();

        return (
            <div ref={this.formRef} className="ContactOfficerContainer">
                {viewForm}
                {viewSuccess}
            </div>
        );
    }
}

module.exports.contactOfficerForm = connect(
    state => ({
        userProfile: state.userProfile,
        extraData: state.extraData,
        steps: state.steps,
        userProfileForm: state.userProfileForm,
        partner: state.products.get('partner'),
    }),
    dispatch => ({
        formActions: bindActionCreators(formActions, dispatch),
        initialActions: bindActionCreators(initialActions, dispatch),
    })
)(contactOfficerForm);
